<template>
  <div class="Message xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img ></hd-img>
        </div>
        <div class="personal-right">
          <div class="top1">
            <div class="flex-start">
              <span style="margin-right: 5px; font-size: 16px;cursor: pointer;" @click="goBack"><i class="el-icon-arrow-left"></i>返回</span>
              <div class="line-title"></div>
              <p style="margin-right: 10px; font-size: 16px">收益明细统计</p>
              <img class="pointer" v-if="isShow" src="../../assets/img/userInfo/preview_open.png" @click="isShow = false" />
              <img class="pointer" v-if="!isShow" src="../../assets/img/userInfo/preview_close.png" @click="isShow = true" />
            </div>
            <div class="flex-space-around">
              <div class="top1-2">
                <div>
                  <img src="../../assets/img/yue.png" style="width: 28px;height: 28px;margin-right: 10px;vertical-align: sub;" alt="">
                  <span>累计返利收益(元)</span>
                  <span class="t-desc" style="margin-left:30px;margin-right: 10px;">￥</span>
                  <span v-if="isShow" class="num" style="color: #F54B20;font-weight: bold;">{{ UserBalance.cumulativeIncome>0?UserBalance.cumulativeIncome.toFixed(2):'0' }}</span>
                  <span v-else class="num">******</span>
                  <span class="t-desc" style="margin-left:10px;">元</span>
                </div>
              </div>  
              <div class="top1-3">
                <div >
                  <span>团队人数(人)</span> <span class="num" style="margin-left: 15px;">{{ UserBalance.commanderTeamCount}}</span>
                </div>
              </div>
              <div class="line-1"></div>
              <div class="top1-4">
                <div class="menu-btn" style="display: flex;align-items: center;">
                  <div class="btn2" @click="$router.push('/personal/teamDetail')">收益明细</div>
                  <div class="btn1" style="margin-left: 20px;" @click="goNext">一键分账</div>
                </div>
              </div>
            </div>
          </div>
          <p style="font-size: 16px; margin: 10px 0">团队人数（{{UserBalance.commanderTeamCount}}人）</p>
          <div class="top2">
            <div class="center-content">
              <el-table :data="UserBalanceTable" border :header-cell-style="{ background: '#F5F5F5' }">
                <el-table-column prop="name" label="团队人员" align="center">
                 
                </el-table-column>
                <el-table-column prop="phone" label="账号(手机号)" align="center">
         
                </el-table-column>
                <el-table-column prop="versionName" label="版本" align="center">
                  <template slot-scope="scope">
                    <div class="btn22">{{scope.row.versionName}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="addressee" label="注册时间" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.createTime | timefilters }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                     <div class="btn11" @click="goSharing(scope.row)">转账</div>
                  </template>
                  
                </el-table-column>
              </el-table>
              <div class="pageBox">
                <el-pagination background layout="total,prev, pager, next" @current-change="AuditCurrentChange" :page-size="15" :current-page.sync="AuditcurrentPage" :total="auditTotal"> </el-pagination>
              </div>
            </div>
          </div>
          <!--    详情    -->
        </div>
      </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>

<script>
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { UserInfo } from "../../components/User/UserInfo";
var pageIndex = 1;
var keywordVal = "";
var myDate = new Date();
export default {
  name: "Message",
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    var shoppingMalltem = new shoppingMall(this.TokenClient, this.Services.shoppingMall);
    var UserDistributorltem = new shoppingMall(this.TokenClient, this.Services.Authorization);
    var user = new UserInfo(this.TokenClient, this.Services.Authorization);
    return {
      userDomain: user,
      UserBalance: {
        assetsBalance: 0,
      },
      labelPosition: "right",
      MessageList: [],
      MessageDetail: {},
      total: 0,
      currentPage: 1, //初始页
      keyword: "",
      PageTotal: 1,
      MessageTotal: 0,
      rloading: [], //loading遮罩
      shoppingMallMain: shoppingMalltem,
      UserDistributorMain: UserDistributorltem,
      Image: {
        //单击图片上传控件中的图片时，放大显示
        dialogVisible: false,
        dialogImageUrl: "",
      },
      dialogVisible: false,
      UserBalanceTable: [],
      type: "0",
      pageIndex: 1,
      valueDate: "",
      auditTotal: 0,
      userInfo: this.$store.state.localData.userInfo,
      startTime: "",
      endTime: "",
      myprice: 0,
      isShow: false,
      userAccountInfo : {
        expenseAmount: 0,
        incomeAmount: 0,
        pendingAmount: 0,
      }
    };
  },
  mounted() {
    this.AllMessages();
  },
  methods: {
       goNext(){
        if (this.UserBalance.commanderTeamCount == 0) {
          this.$message({
            message: '团队人数大于0才可分账',
            type: 'warning'
          })
          return
        }
        this.$router.push('/personal/teamShareBonus')
       },
    goSharing(item){
      this.$router.push({
        name: 'teamSharePer', // 需要在router/index.js给路由配置name
        query: {
          personInfo: JSON.stringify(item)
        }
      })
    },
    AuditCurrentChange(pageNum) {
      this.AuditcurrentPage = pageNum;
      this.pageIndex = pageNum;
      this.getAssetsDetailsListime();
    },
    //返回列表页
    goBack(){
      this.$router.go(-1)
    },
    AllMessages() {
      var _this = this;
      _this.UserDistributorMain.getCommanderAssetsDetails(
        function (data) {
          _this.UserBalance = data.data;
          _this.getAssetsDetailsListime();
        },
        function (err) {
          _this.UserBalance = [];
          console.log(err);
        }
      );
    },
    getAssetsDetailsListime() {
      var _this = this;
      _this.UserDistributorMain.getCommanderTeamList(
        _this.pageIndex,
        function (data) {
          _this.UserBalanceTable = data.data.results;
          _this.auditTotal = data.data.dataTotal;
        },
        function (err) {
          _this.UserBalanceTable = [];
          console.log(err);
        }
      );
    }
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";

#page {
  text-align: center;
  padding: 100px 0 30px;
}
.imgBox {
  display: flex;
  justify-content: space-between;
  margin: 0 60px;
}
.imgBoxurl {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.imgBoxurl1 {
  width: 180px;
  height: 180px;
}
.pageBox {
  text-align: left;
  margin-top: 15px;
}
.top2 {
  padding: 25px 30px;
  background: #fff;
}
.recordtitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
}
.boxtagCheck {
  padding: 0 20px;
  background: linear-gradient(90deg, #00c4ac, #5bd2c3);
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.pointer{
  cursor: pointer;
}
.boxtag {
  cursor: pointer;
  padding: 0 20px;
  background-color: #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
}
.banner {
  width: 100%;
  height: 160px;
  background: url("../../assets/img/news_banner.jpg") center no-repeat;
}

.banner-wrap {
  position: relative;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

.banner-text {
  float: left;
}

.banner-text h3 {
  padding-top: 35px;
  font-size: 26px;
  font-weight: normal;
  color: #ffffff;
}

.banner-text p {
  font-size: 14px;
  color: #ffffff;
  margin-top: 20px;
}
.centercontentMoney {
  margin: 20px;
  background: #f5f5f5;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.centercontentMoney1 {
  width: calc(100% - 300px);
  display: flex;
  justify-content: space-around;
  align-items: baseline;
}
.centercontentMoney2 {
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.centercontentMoney1i {
  font-size: 42px;
}
.centercontentMoney1Money {
  font-size: 48px;
  color: #00afb5;
}
.center-content {
  margin: 10px 0;
}
.banner-text p a {
  color: #ffffff;
  font-size: 14px;
  margin: 0 5px;
}

/**/
.personal-content {
  background: #f7f7f7;
  padding: 40px 0;
}

.personal-box {
  width: 1200px;
  margin: 0 auto;
}

.personal-left {
  float: left;
}

.personal-right {
  float: right;
  width: 985px;
  min-height: 740px;
  /* background: #ffffff; */
  box-sizing: border-box;
}

.personal-right-tit {
  border-bottom: 1px solid #e5e5e5;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.personal-right-tit .iconfont {
  color: #04a290;
  font-size: 24px;
  margin-right: 5px;
}

.personal-right-tit span {
  display: inline-block;
  font-size: 24px;
  font-weight: 700;
  color: #333333;
}

.personal-right-tit span em {
  font-style: normal;
  color: #04a290;
}

.personal-right-tit .el-icon-delete {
  float: right;
  font-size: 18px;
}

.msg-list {
  padding: 0 20px;
}

.msg-list .msg-item {
  padding: 8px 0;
  border-bottom: 1px dashed #e5e5e5;
  line-height: 40px;
  height: 40px;
}

.msg-list .msg-item h4 {
  color: #999999;
  font-weight: normal;
  width: 700px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.msg-list .msg-item.noread h4 {
  color: #333333;
}

.msg-list .msg-item p {
  color: #999999;
}

.msg-detail {
  padding: 20px;
  display: none;
}

.msg-detail .mess-tit {
  text-align: center;
}

.msg-detail .mess-info p {
  text-indent: 28px;
}
.mess-info .item-img {
  margin-right: 10px;
  display: flex;
  justify-content: flex-start;
  justify-items: center;
  flex-wrap: wrap;
}
.item-img img {
  width: 118px;
  height: 118px;
}
  .btn11 {
    background: linear-gradient(90deg, #ff793b, #ff9d70);
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    width: 100px;
    margin: auto;

  }
  .btn22 {
    background: linear-gradient(90deg, #ff9c27, #ffc36f);
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    width: 100px;
     margin: auto;
  }
</style>
<style scoped lang="scss">
.top1 {
  padding: 20px 15px;
  color: #000;
  background: #ffffff;
  border-radius: 8px;
  .line-1 {
    width: 1px;
    height: 70px;
    background: #b9b9b9;
  }
  .right-t {
    margin-left: 10px;
  }
  .top1-1-1 {
    font-weight: bold;
    font-size: 18px;
    color: #333333;
    margin-right: 10px;
  }
  .top1-1-2 {
    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #b5d5d0;
    padding: 0 10px;
  }
  .top1-1-3 {
    color: #333;
  }
  .num {
    font-size: 30px;
    // font-weight: bold;
  }
  .t-desc {
    font-size: 14px;
    font-weight: bold;
  }
  .btn1 {
    background: linear-gradient(90deg, #ff793b, #ff9d70);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .btn2 {
    background: linear-gradient(90deg, #ff9c27, #ffc36f);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .btn3 {
    background: linear-gradient(90deg, #00c4ac, #5bd2c3);
    border-radius: 4px;
    color: #fff;
    padding: 0 20px;
    cursor: pointer;
  }
  .total {
    font-size: 14px;
    color: #ff405e;
  }
}
.line-title {
  width: 2px;
  height: 16px;
  background: #333;
  margin-right: 5px;
  cursor: pointer;
}
</style>
